@if (isSmallScreen) {
  <p>UN INVESTISSEMENT RENTABLE</p>
}

<div class="d-flex flex-column gap-s">
  <pr-color-panel display="success" clazz="man">
    <pr-panel-body clazz="man pas text-center">
      <h3 class="fs-18 fw-600">
        {{ product.netRentProfitability / 100 | percent: '.1' }}
      </h3>
      <span class="fs-12">RAPPORT LOCATIF ANNUEL</span>
    </pr-panel-body>
  </pr-color-panel>
  <pr-color-panel display="neutral" clazz="man">
    <pr-panel-body clazz="man pas text-center">
      <h3 class="fs-18 fw-600">
        {{ 1484 | currency: 'EUR' : 'symbol' : '.0-0' }}(MOCK)
      </h3>
      <span class="fs-12">LOYERS MENSUELS PERÇUS</span>
    </pr-panel-body>
  </pr-color-panel>
</div>
